import * as React from 'react';

export type XIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Defaults to your original SVG fill (black-ish) */
  color?: string;
};

function XIcon({
  size = 25,
  title = 'X',
  className,
  style,
  color = '#222222',
  ...spanProps
}: XIconProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        lineHeight: 0,
        ...style,
      }}
      {...spanProps}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 1668.56 1221.19'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden
        focusable='false'
      >
        <path
          d='M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z'
          fill={color}
        />
      </svg>
    </span>
  );
}

export default XIcon;
